import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M18 6 7 17l-5-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 10-7.5 7.5L13 16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CheckCheck";
const CheckCheck = memo(themed(Icon));
export {
  CheckCheck
};
//# sourceMappingURL=check-check.js.map
